import React, { FC, ReactNode } from 'react';
import Bugsnag from '@bugsnag/js';
import { Alert } from '@hopskipdrive/react-components';
import { Button } from '@mui/material';

import './setUp';

const BugSnagErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);

const ErrorFallback = ({ clearError }) => {
  return (
    <Alert
      severity="error"
      variant="outlined"
      message={'There was an error loading this part of the page'}
      action={
        <Button color="inherit" size="small" onClick={clearError}>
          Try Reloading
        </Button>
      }
    />
  );
};

const ErrorBoundary: FC<{ children: ReactNode; FallbackComponent?: FC }> = ({
  children,
  FallbackComponent,
  ...rest
}) => {
  return BugSnagErrorBoundary ? (
    <BugSnagErrorBoundary
      FallbackComponent={({ clearError }) =>
        FallbackComponent ? (
          <>
            <ErrorFallback clearError={clearError} />
            <FallbackComponent />
          </>
        ) : (
          <ErrorFallback clearError={clearError} />
        )
      }
      {...rest}
    >
      {children}
    </BugSnagErrorBoundary>
  ) : (
    <>{children}</>
  );
};

export { ErrorBoundary };
